
import Vue from "vue";
import { CalendarEvent } from "../../models/calendar-event";
import { CalendarService } from "../../services/calendar-service";
import { GoogleCalendarService } from "../../services/google-calendar-service";
import { UserConfigService } from "../../services/user-config-service";
import AppCalendarWidgetItem from "./CalendarWidgetItem.vue";
import AppCalendarWidgetSettings from "./CalendarWidgetSettings.vue";

interface IEvent {
	text:String;
	color:String;
	startTime:Date;
	endTime?:Date;
	location?:string;
}

interface IGCalEvent {
	event: gapi.client.calendar.Event;
	cal: gapi.client.calendar.CalendarListEntry;
}

export default Vue.extend({
	data() {
		return {
			calendarEvents: [] as CalendarEvent[],
			googleCalendarEvents: [] as IGCalEvent[],
			settingsModal: false
		};
	},
	computed: {
		allEvents():IEvent[] {
			let events = this.calendarEvents.map(c => {
				return {
					text: c.Title,
					color: c.Calendar ? c.Calendar.Color : "var(--main-blue-1)",
					startTime: c.StartTime,
					endTime: c.EndTime
				} as IEvent;
			});

			let googleCalendarEvents = this.googleCalendarEvents.map(c => {
				let start = new Date((c.event.start.dateTime || c.event.start.date) as any);
				let end = new Date((c.event.end.dateTime || c.event.end.date) as any);
				let color = c.cal.backgroundColor;
				return {
					text: c.event.summary,
					color,
					startTime: start,
					endTime: end,
					location: c.event.location || ""
				} as IEvent;
			});

			events = events.concat(googleCalendarEvents);
			return events;
		}
	},
	methods: {
		async fetch() {
			this.calendarEvents = await CalendarService.getWidgetEvents();
			this.googleCalendarEvents = [];
			if (!GoogleCalendarService.isLoggedIn()) return;
			let settings = UserConfigService.getCalendarSettings();
			let googleCalendars = await GoogleCalendarService.getCalendars();
			for (let id of settings.WidgetGoogleCalendarIDs) {
				let startDate = new Date();
				let endDate = new Date();
				endDate.setDate(startDate.getDate() + 14);
				let cal = googleCalendars.find(g => g.id == id) as gapi.client.calendar.CalendarListEntry;
				if (!cal) {
					continue;
				}
				GoogleCalendarService.getCalendarEvents(id, startDate, endDate).then((events) => {
					for (let event of events) {
						this.googleCalendarEvents.push({
							event,
							cal
						});
					}
				});
			}
		},
		openSettings() {
			this.settingsModal = true;
		}
	},
	async created() {
		this.fetch();
	},
	components: {
		AppCalendarWidgetSettings,
		AppCalendarWidgetItem
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
